<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="help-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="me-2 no-bg"
        icon
        :aria-label="$t('common.help_menu')"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>{{ icons.mdiHelpCircleOutline }}</v-icon>
      </v-btn>
    </template>

    <v-list>
      <!-- FAQ (disabled until the content is ready) -->
      <v-list-item disabled>
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiFrequentlyAskedQuestions }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('common.faq') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- User Guides (disabled until the content is ready) -->
      <v-list-item disabled>
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiBookOpenPageVariantOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('common.user_guides') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-2"></v-divider>

      <v-subheader>{{ $t('common.help') }}</v-subheader>

      <!-- General Feedback -->
      <v-list-item
        :href="isProduction ? links.generalFeedback : null"
        :target="isProduction ? '_blank' : null"
        rel="noopener noreferrer"
        @click="openForm('generalFeedback', $event)"
      >
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiCommentQuoteOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('common.general_feedback') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Report a Bug -->
      <v-list-item
        :href="isProduction ? links.reportBug : null"
        :target="isProduction ? '_blank' : null"
        rel="noopener noreferrer"
        @click="openForm('reportBug', $event)"
      >
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiBugOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('common.report_a_bug') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Feature Request: regional administrators only -->
      <v-list-item
        v-if="isRegionalOrAdmin"
        :href="isProduction ? links.featureRequest : null"
        :target="isProduction ? '_blank' : null"
        rel="noopener noreferrer"
        @click="openForm('featureRequest', $event)"
      >
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLightbulbOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('common.feature_request') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  mdiHelpCircleOutline,
  mdiFrequentlyAskedQuestions,
  mdiBookOpenPageVariantOutline,
  mdiCommentQuoteOutline,
  mdiBugOutline,
  mdiLightbulbOutline,
} from '@mdi/js'

export default {
  computed: {
    user_data() { return this.$store.getters['session/userData']() },
    isRegionalOrAdmin() {
      return this.user_data?.role <= 1
    },

    // The forms are only reachable in production; outside it the click is logged instead.
    isProduction() {
      return process.env.NODE_ENV === 'production'
        || process.env.VUE_APP_ENVIRONMENT === 'production'
    },
  },
  methods: {
    openForm(key, event) {
      if (this.isProduction) return

      event.preventDefault()
      // eslint-disable-next-line no-console
      console.log(`[AppBarHelpMenu] ${key} form disabled outside production: ${this.links[key]}`)
    },
  },
  setup() {
    // Google Forms provided by the team; they open in a new tab.
    const links = {
      generalFeedback: 'https://forms.gle/ZFpgz8jXYUFsv5TAA',
      reportBug: 'https://forms.gle/SERtqEizLj1g39ff8',
      featureRequest: 'https://forms.gle/P3dDb9o7jTeAR3xBA',
    }

    return {
      links,

      icons: {
        mdiHelpCircleOutline,
        mdiFrequentlyAskedQuestions,
        mdiBookOpenPageVariantOutline,
        mdiCommentQuoteOutline,
        mdiBugOutline,
        mdiLightbulbOutline,
      },
    }
  },
}
</script>

<style lang="scss">
.help-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
